import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            'AIzaSyCEuQTphQHWTyrb5xxAC0t_o6c3PpmM5J0',
  authDomain:        'vmdproject-d1e0f.firebaseapp.com',
  projectId:         'vmdproject-d1e0f',
  storageBucket:     'vmdproject-d1e0f.appspot.com',
  messagingSenderId: '460854692871',
  appId:             '1:460854692871:web:e44576a4b03d2fb3aaaea2',
  measurementId:     'G-8SJ17QJ4E5',
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const db = getFirestore(app);
